// P2b tanda 4c — TIPOS DE PRODUCTO CONFIGURABLES. Neto lo usan muchas tiendas:
// nada de la ficha asume la tienda, su marca propia ni sus tipos. Este módulo
// es LA CONFIGURACIÓN SEMBRADA (la única copia de la semilla): reproduce el
// comportamiento previo de la tienda fundadora (dos tipos, "Prendas" y
// "Belleza") para que no note el cambio. Lo editado en Configuración → Catálogo
// (config.catalogo.tiposProducto) MANDA sobre esta semilla; acá solo vive el
// default de primera instalación y los helpers puros que lo consumen.

// Arquetipos del theme Vitrina: deciden la meta _vitrina_arquetipo que viaja a
// WooCommerce. 'ninguno' = no escribir arquetipo. P3-3: se suma 'consumible'
// (contrato del consumible v0.7.388) — un tipo con ese arquetipo escribe
// _vitrina_arquetipo='consumible' por producto (decisión D4). La sección de
// campos comestibles de la ficha es P3-5b (motor en backend/consumibles/).
const ARQUETIPOS = ['prenda', 'cosmetico', 'consumible', 'ninguno'];

const TIPOS_PRODUCTO_DEFAULT = [
  {
    // Los ids se conservan de la era pre-4c: los borradores viejos guardan
    // productKind con estos valores y deben seguir resolviendo.
    id: 'ropa',
    nombre: 'Prendas',
    arquetipo: 'prenda',
    marcaObligatoria: false,
    aplicaGtin: false,
    aplicaTallas: true,
    aplicaContenido: false,
    detallesSugeridos: ['Material', 'Silueta', 'Cuello/escote', 'Largo', 'Tallas disponibles', 'Diseñado y confeccionado en Medellín, Colombia'],
    cierreTitulo: 'Cómo combinarlo',
    // Tanda 5 (parte 0): palabras que sugieren Prendas por la categoría. El
    // match ignora tildes ("pantalón" sugiere también en "Pantalones").
    categoriasQueSugieren: ['ropa', 'prenda', 'top', 'body', 'vestido', 'falda', 'pantalón'],
  },
  {
    id: 'belleza',
    nombre: 'Belleza',
    arquetipo: 'cosmetico',
    marcaObligatoria: true,
    aplicaGtin: true,
    aplicaTallas: false,
    aplicaContenido: true,
    detallesSugeridos: ['Marca', 'Tipo de producto', 'Acabado', 'Contenido (ml o g)', 'Tonos disponibles'],
    cierreTitulo: 'Cómo usarlo / Qué tono elegir',
    // Sugerencia por categoría: match por SUBSTRING (case-insensitive) sobre el
    // nombre de la categoría o sus ancestros. "beauty" cubre también las
    // categorías compuestas de la tienda sin nombrarlas acá.
    categoriasQueSugieren: ['beauty', 'belleza'],
  },
];

// P3-12 (remate): PROPORCIÓN DE FOTO por tipo. La subida/encuadre/tubería dejan de ser 4:5 fijo y
// siguen la proporción del tipo. Ancho fijo 1600; alto según la proporción. Default por arquetipo
// (medido en el theme Vitrina: prenda 4:5, cosmético/consumible 1:1). CJS compartido back+front.
const PROPORCIONES_FOTO = {
  '4:5': { ratioW: 4, ratioH: 5, w: 1600, h: 2000, css: '4 / 5', label: '4:5 (vertical)' },
  '1:1': { ratioW: 1, ratioH: 1, w: 1600, h: 1600, css: '1 / 1', label: '1:1 (cuadrada)' },
  '3:4': { ratioW: 3, ratioH: 4, w: 1600, h: 2133, css: '3 / 4', label: '3:4 (vertical)' },
};
const PROPORCION_FOTO_DEFAULT = '4:5';
// Migración invisible: prenda → 4:5, el resto (cosmético/consumible/ninguno) → 1:1.
function proporcionFotoDefault(arquetipo) {
  return arquetipo === 'prenda' ? '4:5' : '1:1';
}
// La proporción efectiva de un tipo: la configurada (si es válida) manda; si no, el default por su
// arquetipo. Un tipo sin `proporcionFoto` (config vieja) se comporta como su arquetipo.
function proporcionFotoDeTipo(tipo) {
  const p = tipo && tipo.proporcionFoto;
  if (p && PROPORCIONES_FOTO[p]) return p;
  return proporcionFotoDefault(tipo && tipo.arquetipo);
}
function dimsProporcionFoto(prop) {
  return PROPORCIONES_FOTO[prop] || PROPORCIONES_FOTO[PROPORCION_FOTO_DEFAULT];
}
// Atajo: dims efectivas de un tipo (ratioW/ratioH/w/h/css/label). Es lo que el editor de encuadre,
// la tubería y el criterio de baja resolución consumen (el `label` ya trae «4:5 (vertical)», etc.).
function dimsFotoDeTipo(tipo) {
  return dimsProporcionFoto(proporcionFotoDeTipo(tipo));
}
// Objeto listo para el editor/tubería: { ratioW, ratioH, maxW, maxH, label } de un tipo.
function propFotoDeTipo(tipo) {
  const d = dimsFotoDeTipo(tipo);
  return { ratioW: d.ratioW, ratioH: d.ratioH, maxW: d.w, maxH: d.h, label: d.label };
}

// La lista vigente: lo configurado si existe y es una lista no vacía; si no, la semilla.
function tiposConfigurados(catalogoConfig) {
  const lista = catalogoConfig && catalogoConfig.tiposProducto;
  return Array.isArray(lista) && lista.length ? lista : TIPOS_PRODUCTO_DEFAULT;
}

function tipoPorId(tipos, id) {
  return (tipos || []).find((t) => t && t.id === id) || null;
}

// El tipo del formulario, con fallback al PRIMERO (un form nuevo o un id que ya
// no existe en la config no dejan la ficha sin plantilla).
function tipoActivo(tipos, id) {
  return tipoPorId(tipos, id) || (tipos || [])[0] || null;
}

// Tanda 8c (J9): ¿el tipo lleva "Contenido" (ml/g) en la ficha y sus variaciones?
// El flag aplicaContenido MANDA; si el tipo no lo declara (configs guardadas
// ANTES de 8c, que no traían el campo) se cae al arquetipo cosmético — así
// ninguna config vieja pierde la columna sin migración. Un tipo sin flag y sin
// arquetipo cosmético NO lleva contenido. Fuente única del criterio: lo comparten
// la columna de la ficha (ProductPage) y la regla de fichaEstado.
function aplicaContenidoDeTipo(tipo) {
  if (!tipo) return false;
  if (typeof tipo.aplicaContenido === 'boolean') return tipo.aplicaContenido;
  return tipo.arquetipo === 'cosmetico';
}

// La meta _vitrina_arquetipo del GET → id del tipo configurado (el primero que
// declare ese arquetipo). null si ninguno lo declara.
function tipoIdPorArquetipo(tipos, arquetipo) {
  if (!ARQUETIPOS_ESCRIBIBLES.has(arquetipo)) return null;
  const t = (tipos || []).find((x) => x && x.arquetipo === arquetipo);
  return t ? t.id : null;
}

// El arquetipo que viaja a Woo para un productKind dado ('prenda' | 'cosmetico'
// | 'consumible' | null). 'ninguno' y un tipo sin arquetipo devuelven null (no
// se escribe la meta).
const ARQUETIPOS_ESCRIBIBLES = new Set(['prenda', 'cosmetico', 'consumible']);
function arquetipoDeTipo(tipos, id) {
  const t = tipoActivo(tipos, id);
  const a = t && t.arquetipo;
  return ARQUETIPOS_ESCRIBIBLES.has(a) ? a : null;
}

// Sin tildes y en minúsculas: el match de sugerencia no depende de cómo se
// acentuó la categoría ("pantalón" debe encontrar "Pantalones").
function llano(s) {
  return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
}

// Deducción por categorías (sugerido, nunca tocado): el primer tipo cuya lista
// categoriasQueSugieren matchee (substring, sin mayúsculas ni tildes) el nombre
// de alguna categoría del producto O de sus ANCESTROS vía el catálogo. null si
// ninguno — el consumidor cae al PRIMER tipo de la lista (dicho en la ayuda de
// Configuración → Catálogo).
function tipoSugeridoPorCategorias(tipos, categorias, catalog = []) {
  const porId = new Map((catalog || []).map((c) => [c.id, c]));
  const nombres = [];
  for (const c of categorias || []) {
    nombres.push(String(c.name || ''));
    let actual = porId.get(c.id);
    const vistos = new Set();
    while (actual && !vistos.has(actual.id)) {
      vistos.add(actual.id);
      nombres.push(String(actual.name || ''));
      actual = porId.get(actual.parent);
    }
  }
  const todo = nombres.map(llano);
  for (const t of tipos || []) {
    const claves = (t && t.categoriasQueSugieren) || [];
    if (claves.some((k) => k && todo.some((n) => n.includes(llano(k))))) return t.id;
  }
  return null;
}

// Tanda 6 (parte 0, reemplaza a categoriaAplicaTallas de la 5): el tipo de una
// categoría SOLO por coincidencia POSITIVA (palabras o ancestro). null = la
// categoría no coincide con ningún tipo — va al grupo "Sin tipo definido" del
// editor de guías, nunca al principal por un fallback silencioso (el fallback
// al primer tipo sigue siendo la regla del FORMULARIO, no de esta lista).
function tipoPositivoDeCategoria(tipos, categoria, catalog = []) {
  const id = tipoSugeridoPorCategorias(tipos, [categoria], catalog);
  return id ? tipoPorId(tipos, id) : null;
}

// Iniciales del nombre de la tienda: el prefijo de SKU de marca propia cuando
// no hay uno configurado ("Nombre Apellido Tienda" → primeras letras, máx. 4).
function inicialesDeNombre(nombre) {
  return String(nombre || '')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toUpperCase()
    .split(/[^A-Z0-9]+/).filter(Boolean)
    .map((w) => w[0])
    .join('')
    .slice(0, 4);
}

// Prefijo de SKU de productos de marca propia: el configurado gana; si falta,
// las iniciales del nombre de la tienda; si tampoco hay nombre, vacío.
function prefijoSkuPropio(catalogoConfig, nombreTienda) {
  const p = String((catalogoConfig && catalogoConfig.skuPrefijoPropio) || '').trim().toUpperCase();
  if (p) return p;
  return inicialesDeNombre(nombreTienda);
}

// CJS a propósito (tanda 6): el evaluador de ficha (fichaEstado.js) corre
// también en el BACKEND (materialización) y require() no lee módulos ES —
// mismo patrón que groupOrdersByProduct. Los import de CRA lo consumen igual.
module.exports = {
  ARQUETIPOS, TIPOS_PRODUCTO_DEFAULT, tiposConfigurados, tipoPorId, tipoActivo,
  tipoIdPorArquetipo, arquetipoDeTipo, tipoSugeridoPorCategorias,
  inicialesDeNombre, prefijoSkuPropio, tipoPositivoDeCategoria, aplicaContenidoDeTipo,
  // P3-12 remate: proporción de foto por tipo.
  PROPORCIONES_FOTO, PROPORCION_FOTO_DEFAULT, proporcionFotoDefault, proporcionFotoDeTipo,
  dimsProporcionFoto, dimsFotoDeTipo, propFotoDeTipo,
};
